import { DocumentMeta, createDocumentMeta } from '../meta';
import { Action, ActionName, createAction, groupActions, ActionsOptions, WaterfallData } from './action';

export interface Block {
  _meta?: DocumentMeta;
  id: string;
  timestamp: number;
  name: string;
  actions: Record<number, Action>
}

export function createBlock(params: Partial<Block> = {}): Block {
  return {
    id: '',
    name: '',
    actions: {},
    timestamp: new Date().getTime(),
    ...params,
  }
}

export function buildBlock(name: string, actions: Partial<Action>[], date: Date, createdBy: string) {
  const block = createBlock({
    _meta: createDocumentMeta({ createdBy }),
    timestamp: date.getTime(),
    name
  });
  let actionId = 0;
  for (const action of actions) {
    block.actions[actionId] = createAction({ ...action, actionId });
    actionId++;
  }
  return block;
}

function getBlockName(date: Date, actions: Action[]) {
  const dateStr = `${date.toLocaleDateString()}`;
  const actionsNames = Array.from(new Set(actions.map(a => a.name)));

  const paymentActions: ActionName[] = ['payment']; // External payments made after the statement date end
  const statementsActions: ActionName[] = ['expense', 'income', 'payment']; // Expenses, incomes and internal payments
  const contractsActions: ActionName[] = ['contract', 'updateContract', 'invest'];
  const rightsActions: ActionName[] = ['append', 'prepend', 'prependHorizontal', 'appendHorizontal', 'appendVertical', 'prependVertical'];

  if (actionsNames.every(n => paymentActions.includes(n))) return `payments-${dateStr}`;
  if (actionsNames.every(n => statementsActions.includes(n))) return `statements-${dateStr}`;
  if (actionsNames.every(n => contractsActions.includes(n))) return `contracts-${dateStr}`;
  if (actionsNames.every(n => rightsActions.includes(n))) return `rights-${dateStr}`;
  return `mixed-${dateStr}`;
}

export function buildBlocks(data: WaterfallData, createdBy: string, versionId: string, options?: ActionsOptions) {
  const groupedActions = groupActions(data, versionId, options);

  return groupedActions.map(group => {
    const blockName = getBlockName(group.date, group.actions);
    return buildBlock(blockName, group.actions, group.date, createdBy);
  });
}